



























import { Component, Prop, Vue } from "vue-property-decorator";
import { IFiltersOptions } from "@/models/tables";

@Component
export default class SelectRadioGroupFilter extends Vue {
  @Prop({ required: true })
  public value!: any;
  @Prop({ default: null })
  public filterId!: any;
  @Prop({ default: null })
  public filterKey!: any;
  @Prop({ required: true })
  public options!: IFiltersOptions[];
  @Prop({ default: null })
  public type!: string;
  @Prop({ default: false })
  public disabled!: boolean;
  @Prop({ default: null })
  public size!: string;

  public getOptionLabel(option) {
    return this.$_.startsWith(option.label, "_")
      ? this.$t(option.label)
      : option.label;
  }
}
